import Alert from "@mui/material/Alert";
import React from "react";

function SuccessMessage({ message }) {
  return <Alert severity="success">{message}</Alert>;
}

export default SuccessMessage;
